import { lazy } from "react";
import { CiMonitor } from "react-icons/ci";
import {
  CalculatorOutlined,
  DownloadOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  ReconciliationOutlined,
  UploadOutlined,
} from "@ant-design/icons";

const RequestInbound = lazy(() => import("../pages/auth/RequestInbound"));
const RequestOutbound = lazy(() => import("../pages/auth/RequestOutbound"));
const InvoiceClient = lazy(() => import("../pages/auth/InvoiceClient"));
const DashboardClient = lazy(() => import("../pages/auth/Dashboard/dashboard-client"));
const Rules = lazy(() => import("../pages/auth/Rules"));
const StockOverviewClient = lazy(() => import("../pages/auth/StockOverview/stock-overview-client"));

export const MENU_LIST_CLIENTS = [
  {
    name: "Dashboard",
    code: "Dashboard",
    icon: <CiMonitor />,
    path: "/dashboard",
    element: <DashboardClient />,
  },
  {
    name: "Request Inbound",
    code: "Inbound",
    icon: <DownloadOutlined />,
    path: "/request-inbound",
    element: <RequestInbound />,
  },
  {
    name: "Request Outbound",
    code: "Outbound",
    icon: <UploadOutlined />,
    path: "/request-outbound",
    element: <RequestOutbound />,
  },
  {
    name: "Transaction",
    code: "Transaction",
    icon: <FileTextOutlined />,
    path: "/transaction-client",
    element: <InvoiceClient />,
  },
  {
    name: "Stock Overview",
    code: "Stock Overview",
    icon: <ReconciliationOutlined />,
    path: "/stock-overview-client",
    element: <StockOverviewClient />,
  },
  {
    name: "Policy & Price List",
    code: "Policy & Price List",
    icon: <FileProtectOutlined />,
    path: "/policy",
    element: <Rules />,
  },
  {
    name: "Calculator Biaya Penyimpanan",
    code: "Calculator Biaya",
    icon: <CalculatorOutlined />,
    path: "/calculator",
    newTab: true,
  },
];
